export const CONSTANTS = {
    DEFAULT_STRING_VALUE: "",
    DEFAULT_NO_OF_TRAVELLERS: 10,
    AVAILABLE: "Available",
    UNAVAILABLE: "Unavailable",
    PENDING: "Pending",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    CONFIRMED: "Confirmed",
    MODAL: "MODAL",
    QUOTE: "quote",
    SHOW: "show",
    HIDE: "hide",
    BRAND_DEFAULT: "swg",
    BRAND_WVI: "wvi",
    BRAND_VWQ: "vwq",
    SEARCH_ALIAS_DEFAULT: "qma",
    IQM: "IQM",
    AGENT: "AGENT",
    MARKUP_TYPE_PERCENT: "percent",
    MARKUP_TYPE_AMOUNT: "amount",
    MARKUP_COVERAGE_ALL: "all",
    MARKUP_COVERAGE_INDIVIDUAL: "individual",
    HOTEL: "hotel",
    CRUISE: "cruise",
    PACKAGE: "package",
    FLIGHT: "flight",
    DEVIATION: "deviation",
    DAYS: "days",
    NO_PLANNING_SERVICE_REQUIRED: "no-planning-service-required"
};

export const TOKENS = {
    NUM: "NUM",
    DATE: "DATE",
    INT: "INT",
    MONEY: "MONEY",
    SUM: "SUM",
    VAR: "VAR",
    SUFFIX: "SFX",
    INC: "INC",
    DEC: "DEC",
    NONE: "NONE"
};